import uploadApi from './UploadApi.js';
import commonApi from './CommonApi.js';

export default {	
	getAll: async (parameter) => {
		return await commonApi().get('/v1/admin/aiDocuments/getAll', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getById: async (parameters) => {
		return await commonApi().get('/v1/admin/aiDocuments/getById', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	create: async (formData) => {
		return await uploadApi().post('/v1/admin/aiDocuments',
			formData, {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'multipart/form-data'
			}
		})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	edit: async (formData) => {
		return await uploadApi().put('/v1/admin/aiDocuments',
			formData, {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'multipart/form-data'
			}
		})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},	
	delete: async (parameters) => {
		return await commonApi().delete('/v1/admin/aiDocuments', { params: parameters })
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
}